import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PurchaseVariant8 = lazyWithPreload(
  () => import('./PurchaseVariant8'),
)
